
import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import * as Yup from "yup";
import {useFormik} from "formik";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FilledInput from "@material-ui/core/FilledInput";
import MenuItem from "@material-ui/core/MenuItem";
import CardHeader from "@material-ui/core/CardHeader";
import {Card, CardBody} from "../../../../_metronic/_partials/controls";
import {injectIntl} from "react-intl";
import Grid from "@material-ui/core/Grid";
import {fetchSuppliers, newPriceList, updatePriceList} from "../AdminPagesCrud";

function EditOrAddPriceList({priceList, supplier, edit, setEdit, isNew, setIsNew, setShowSnackbar, showSnackbar, intl}){

    // const {id} = useParams();
    const [clients] = useState(priceList?.clients?.length)
    const [products] = useState(priceList?.products?.length)
    const [supplierName, setSupplierInfo] = useState(supplier)


    const {accessToken} = useSelector (
        ({auth}) =>({
            accessToken: auth.authToken,
        })
    )

    useEffect(() => {
        if(isNew){
            fetchSuppliers(supplier, accessToken).then(response => {
                setSupplierInfo(response.data.entityName)
            })
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const priceListSchema = Yup.object().shape({
        name: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
    });

    const formik = useFormik({
        initialValues: priceList,
        validationSchema: priceListSchema,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            try {
                if(isNew){

                    values.products = []
                    values.clients = []
                    values.supplierId = supplier
                    newPriceList(values, accessToken).then((response) => {
                        setIsNew(!isNew)
                        setShowSnackbar(!showSnackbar)
                    })
                }
                else {
                updatePriceList(priceList._id, values, accessToken).then((response) => {
                    setEdit(!edit)
                    setShowSnackbar(!showSnackbar)
                })
                }

            } catch (e) {
                alert("An error occurred");
                console.log(e.message);
            }
        },
    });


    return (
        <>
            <Card>
                {edit ? <CardHeader title="Edit Price List"/> : <CardHeader title="New Price List"/> }
                <CardBody>
                    <form onSubmit={formik.handleSubmit}>
                        <div>
                            <div className="">
                                <div className="col-12">
                                    <Grid container>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel>Price List Name</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="name"
                                                        {...formik.getFieldProps("name")}
                                                    />
                                                    {formik.touched.name && formik.errors.name ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div
                                                                className="fv-help-block">{formik.errors.name}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel htmlFor="sku">Supplier</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="sku"
                                                        value={supplierName}
                                                        disabled
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel htmlFor="sku">Amount of Clients</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="clients"
                                                        value={clients}
                                                        disabled
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel htmlFor="sku">Amount of Products</InputLabel>
                                                    <input
                                                        type="text"
                                                        className={`form-control form-control-solid h-auto py-2 px-6`}
                                                        name="products"
                                                        value={products}
                                                        disabled
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <div className="form-group fv-plugins-icon-container">
                                                    <InputLabel >Is Active</InputLabel>
                                                    <Select
                                                        input={<FilledInput name="active" id="active"
                                                                            type="text"
                                                                            className={`form-control form-control-solid h-2 py-2 px-6`}
                                                                            {...formik.getFieldProps("active")}
                                                        />}
                                                    >
                                                        <MenuItem value={true}>Yes</MenuItem>
                                                        <MenuItem value={false}>No</MenuItem>

                                                    </Select>
                                                    {formik.touched.active && formik.errors.active ? (
                                                        <div className="fv-plugins-message-container">
                                                            <div className="fv-help-block">{formik.errors.active}</div>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </div>
                                <div className="col-12 row justify-content-center">
                                    <button className="btn btn-primary" type="submit">
                                        Save
                                    </button>
                                    <div className="pl-4"/>
                                    <button className="btn btn-secondary" type="button" onClick={() => setEdit(!edit)}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </CardBody>
            </Card>
        </>
    )
}

export default injectIntl(EditOrAddPriceList);
